<template>
  <v-dialog
    :value="value"
    max-width="780"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card class="neo-surface rounded-xl overflow-hidden">
      <v-toolbar flat dense class="mo-toolbar">
        <v-btn icon small class="white--text mr-1" @click="close">
          <v-icon color="white" small>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text d-flex align-center">
          <v-icon left color="white" class="mr-2">mdi-pallet</v-icon>
          Detail Pallet
        </v-toolbar-title>
      </v-toolbar>
      <div class="position-relative">
        <canvas ref="bgCanvas" class="bg-canvas"></canvas>
        <div class="pa-6 neo-surface">
          <v-skeleton-loader v-if="loading" type="article, table, actions" />
          <div v-else>
            <v-row dense>
              <v-col cols="12">
                <div class="mo-header value emphasis-1">
                  {{ detail.company_name || '-' }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="label">NO PALET</div>
                <div class="value strong">{{ detail.passed_no || '-' }}</div>
              </v-col>
              <v-col cols="6">
                <div class="label">NO LOT</div>
                <div class="value">{{ detail.lot_no || '-' }}</div>
              </v-col>
              <v-col cols="6">
                <div class="label">NO PRODUKSI</div>
                <div class="value">{{ detail.production_no || '-' }}</div>
              </v-col>
              <v-col cols="6">
                <div class="label">TGL PRODUKSI</div>
                <div class="value">{{ detail.date_planned_start }}</div>
              </v-col>
              <v-col cols="6">
                <div class="label">KODE PRODUK</div>
                <div class="value">{{ detail.product_code }}</div>
              </v-col>
              <v-col cols="6">
                <div class="label">NAMA PRODUK</div>
                <div class="value uppercase">{{ detail.product_name }}</div>
              </v-col>
              <v-col cols="6">
                <div class="label">MESIN</div>
                <div class="value">{{ detail.machine_name || '-' }}</div>
              </v-col>
              <v-col cols="6">
                <div class="label">SHIFT</div>
                <div class="value">{{ detail.shift_name || '-' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="label">QTY PRODUKSI</div>
                <div class="value">
                  {{ formatNumber(detail.qty_production) }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="label">SISA DI PALLET</div>
                <div class="value">{{ formatNumber(detail.qty_remain) }}</div>
              </v-col>
              <v-col cols="12">
                <div class="label">JUMLAH LOADING</div>
                <div class="value">
                  <v-text-field
                    v-model.number="inputQty"
                    class="neo-input"
                    label="Masukkan jumlah barang yang ingin dimuat"
                    type="number"
                    min="0"
                    dense
                    outlined
                    style="height:45px;"
                  />
                  <p style="padding:0; margin:0; font-size:11px;">Note: <br>{{ `Qty demand = ${memoItem.qty}` }} <br>{{ `Qty yang sudah dimuat = ${memoItem.loaded_qty}` }} </p>
                </div>
              </v-col> </v-row
            ><v-row dense class="mt-5">
              <v-col cols="12">
                <v-btn block class="neo-btn" @click="saveQty">SIMPAN</v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn block class="neo-btn mt-1" @click="close"> BATAL</v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PalletDetailComponent',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    detail: { type: Object, default: () => ({}) },
    memoItem: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      inputQty: 0
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.$nextTick(() => this.drawBackground())
        window.addEventListener('resize', this.drawBackground)
      } else {
        window.removeEventListener('resize', this.drawBackground)
      }
    }
  },
  methods: {
    saveQty() {
      const palletId = this.detail?.id ?? null
      const qtyLoading = this.inputQty

      setTimeout(() => {
        if (palletId == null) return
        this.$emit('saveQty', {
          pallet_id: palletId,
          qty_loading: qtyLoading
        })
        this.inputQty = 0
      }, 100)
    },
    close() {
      this.inputQty = 0
      setTimeout(() => {
        this.$emit('input', false)
      }, 100)
    },
    formatNumber(value) {
      if (value == null || value === '') return '0'
      const parsed = Number(value)
      if (Number.isNaN(parsed)) return String(value)
      try {
        return parsed.toLocaleString('id-ID')
      } catch (err) {
        return String(parsed)
      }
    },
    drawBackground() {
      const canvas = this.$refs.bgCanvas
      if (!canvas) return
      const container = canvas.parentElement
      const w = container.clientWidth
      const h = 200
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)
      const g1 = ctx.createRadialGradient(
        w * 0.2,
        h * 0.5,
        10,
        w * 0.2,
        h * 0.5,
        150
      )
      g1.addColorStop(0, 'rgba(144,202,249,.35)')
      g1.addColorStop(1, 'rgba(144,202,249,0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.2, h * 0.55, 120, 0, Math.PI * 2)
      ctx.fill()
      const g2 = ctx.createRadialGradient(
        w * 0.75,
        h * 0.2,
        10,
        w * 0.75,
        h * 0.2,
        130
      )
      g2.addColorStop(0, 'rgba(165,214,167,.35)')
      g2.addColorStop(1, 'rgba(165,214,167,0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.75, h * 0.25, 120, 0, Math.PI * 2)
      ctx.fill()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.mo-header {
  text-align: center;
  min-height: 28px;
  padding-top: 2px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
  color: #37474f;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 200px;
  pointer-events: none;
}
.label {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 2px;
}
.value {
  color: #263238;
}
.value.emphasis-1 {
  font-size: 1.25rem;
  font-weight: 700;
}
.value.emphasis-2 {
  font-size: 1.1rem;
  font-weight: 600;
}

.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 10px 16px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
</style>
